import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Row, Col } from "reactstrap";
import ChatIcon from '@mui/icons-material/Chat';
import Mic from "../../../assets/Icons/mic.svg";
import MicMute from "../../../assets/Icons/mic-mute.svg";
import Camera from "../../../assets/Icons/camera.svg";
import CameraOff from "../../../assets/Icons/camera-off.svg";
import Phone from "../../../assets/Icons/phone.svg";
import { useSocket } from "../../../store/context/SocketProvider";
import { Tabs } from "antd";
import { ToastContainer } from "react-toastify";
import Video from "../Video";
import VideoChat from "../VideoChat";
import UserStream from "./UserStream";
import Participants from "./Participants";

export default function VideoMeetingSession() {
  const {
    endMeeting,
    localStream,
    streams,
    muteStream,
    unmuteStream,
    turnOffVideo,
    turnOnVideo,
    isMuted,
    isVideoTrack,
    isGroupCall,
    isVideoCall
  } = useSocket();

  const videoMeeting = useSelector((state) => state.videoMeeting);
  const { me, meetId } = videoMeeting;
  const [showChat, setShowChat] = useState(false);

  const [activeStream, setActiveStream] = useState(null);
  const [activeUser, setActiveUser] = useState({});

  const maximizeUserVideo = (stream, user) => {
    console.log("video maximised", stream, user);
    // Extract the actual MediaStream from the stream object
    const mediaStream = stream?.current ? stream.current : stream;
    setActiveStream(mediaStream);
    setActiveUser(user);
  };

  useEffect(() => {
    console.log('streams:', streams);
    // Extract the actual MediaStream from localStream ref
    const mediaStream = localStream?.current ? localStream.current : localStream;
    setActiveStream(mediaStream);
    setActiveUser(me);
  }, [localStream, me, turnOnVideo]);

  const toggleChat = () => {
    var userChat = document.getElementsByClassName("user-chat");
    if (userChat) {
      userChat[0].classList.add("user-chat-show");
    }
    setShowChat((prev) => !prev);
  }

  return (
    <Row className="g-1 mt-2 position-relative video-call-container">
      <Col lg={8} className="col-xxl-8 col-md-8 col-12 p-0 h-100">
        <div id="videomeeting-session" className="w-100 h-100 position-relative overflow-hidden">
          <h3 id="meet-h1" className="hidden md:block md:absolute md:left-0 md:right-0 md:m-auto md:text-center md:top-3 md:z-10">{meetId}</h3>
          <div className="pt-2 px-2 w-full d-flex flex-wrap justify-content-center align-items-center h-100 position-relative">
            <div
              className="w-full bg-black rounded-md text-white text-base font-semibold position-relative"
            >
              <div className="active-userinfo px-3 py-2 border-bottom">
                <div className="d-flex align-items-center">
                  {activeUser?.imageSrc && activeUser?.imageSrc !== "" ? (
                    <div className="me-2">
                      <img
                        src={activeUser.imageSrc}
                        alt="User Avatar"
                        className="rounded-circle"
                        style={{ width: "36px", height: "36px", objectFit: "cover" }}
                      />
                    </div>
                  ) : (
                    <div className="me-2">
                      <div
                        className="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center"
                        style={{ width: "36px", height: "36px", fontSize: "16px", fontWeight: "500" }}
                      >
                        {activeUser?.contactName?.first?.charAt(0)?.toUpperCase()}
                      </div>
                    </div>
                  )}
                  <div>
                    <div className="fw-semibold text-light">
                      {activeUser?.contactName?.first} {activeUser?.contactName?.last}
                    </div>
                  </div>
                </div>
              </div>

              <div id="controls" className="position-absolute bottom-0 start-50 translate-middle-x">
                <div className="d-flex justify-content-center align-items-center gap-3 bg-dark bg-opacity-50 px-4 py-2 rounded-pill">
                  {/* Mic Button */}
                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle bg-primary"
                    style={{ width: "40px", height: "40px", cursor: "pointer" }}
                  >
                    {isMuted ? (
                      <img src={MicMute} alt="mic-mute" onClick={unmuteStream} style={{ width: "18px" }} />
                    ) : (
                      <img src={Mic} alt="mic" onClick={muteStream} style={{ width: "18px" }} />
                    )}
                  </div>

                  {/* Camera Button (1:1 call) */}
                  {!isGroupCall && (
                    <div
                      className="d-flex justify-content-center align-items-center rounded-circle bg-primary"
                      style={{ width: "40px", height: "40px", cursor: "pointer" }}
                    >
                      {!isVideoTrack ? (
                        <img src={CameraOff} alt="camera-off" onClick={turnOnVideo} style={{ width: "18px" }} />
                      ) : (
                        <img src={Camera} alt="camera" onClick={turnOffVideo} style={{ width: "18px" }} />
                      )}
                    </div>
                  )}

                  {/* Camera Button (Group Call) */}
                  {isGroupCall && isVideoCall && (
                    <div
                      className="d-flex justify-content-center align-items-center rounded-circle bg-primary"
                      style={{ width: "40px", height: "40px", cursor: "pointer" }}
                    >
                      {!isVideoTrack ? (
                        <img src={CameraOff} alt="camera-off" onClick={turnOnVideo} style={{ width: "18px" }} />
                      ) : (
                        <img src={Camera} alt="camera" onClick={turnOffVideo} style={{ width: "18px" }} />
                      )}
                    </div>
                  )}

                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle bg-primary text-black d-md-none"
                    style={{ width: "40px", height: "40px", cursor: "pointer" }}
                    onClick={toggleChat}
                  >
                    <ChatIcon style={{ fontSize: "20px" }} />
                  </div>

                  {/* End Call Button */}
                  <div
                    className="d-flex justify-content-center align-items-center rounded-circle bg-danger "
                    style={{ width: "40px", height: "40px", cursor: "pointer" }}
                    onClick={() => endMeeting("Meet179")}
                  >
                    <img src={Phone} alt="phone" style={{ width: "18px" }} />
                  </div>
                </div>
              </div>

              {activeStream ? (
                <Video
                  stream={activeStream} // Now passing the actual MediaStream, not a ref
                  id="my-video"
                  muted={true}
                  style={{
                    transform: `rotateY(180deg)`,
                    zIndex: 1,
                    objectFit: 'cover'
                  }}
                />
              ) : (
                <div className="d-flex justify-content-center align-items-center text-center bg-dark" style={{ height: '400px' }}>
                  <h5 className="text-light">Camera is off</h5>
                </div>
              )}
            </div>

            <div id="users-stream" className="rounded-md mt-4">
              {/* Pass the actual MediaStream to UserStream */}
              <UserStream 
                stream={localStream?.current ? localStream.current : localStream} 
                user={me} 
                mute={true} 
                maximizeUserVideo={maximizeUserVideo} 
              />

              {streams.length > 0 ? (
                streams.map((obj) => (
                  <UserStream
                    key={obj.user._id}
                    stream={obj.stream?.current ? obj.stream.current : obj.stream}
                    user={obj.user}
                    mute={obj.mute}
                    maximizeUserVideo={maximizeUserVideo}
                  />
                ))
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center text-center bg-light"
                  style={{
                    height: "150px",
                    width: "220px",
                  }}
                >
                  <h5 className="text-muted mb-1">Waiting for Participants</h5>
                </div>
              )}
            </div>
          </div>
        </div>
      </Col>
      <Col lg={4} className={`col-xxl-4 col-md-4 col-12 p-0 user-chat h-100 border-start  ${showChat && "user-chat-show"}`}>
        <div className="w-100 position-relative">
          {isGroupCall ?
            <div className="rounded-md">
              <Tabs
                type="card"
                items={new Array(2).fill(null).map((_, i) => {
                  const id = String(i + 1);
                  return {
                    label: id == 1 ? "Chats" : "Participants",
                    key: id,
                    children: id == 1 ? <VideoChat isShow={showChat} /> : <Participants streams={streams} me={me} localStream={localStream} isMuted={isMuted} isVideoTrack={isVideoTrack} isGroupCall={isGroupCall} isVideoCall={isVideoCall} muteStream={muteStream} unmuteStream={unmuteStream} turnOnVideo={turnOnVideo} turnOffVideo={turnOffVideo} maximizeUserVideo={maximizeUserVideo} />,
                  };
                })}
              />
            </div>
            :
            <Participants
              streams={streams}
              me={me}
              localStream={localStream}
              isMuted={isMuted}
              isVideoTrack={isVideoTrack}
              isGroupCall={isGroupCall}
              isVideoCall={isVideoCall}
              muteStream={muteStream}
              unmuteStream={unmuteStream}
              turnOnVideo={turnOnVideo}
              turnOffVideo={turnOffVideo}
              maximizeUserVideo={maximizeUserVideo}
            />}
        </div>
      </Col>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Row>
  );
}